import * as marked from 'marked';
import { VNodeDirective, VNode } from 'vue';

export default {
	inserted(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
		const renderer = new marked.Renderer();
		renderer.link = (href, title, text) => {
			return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
		};

		marked.setOptions({
			sanitize: true,
			renderer,
		});

		if (binding.value) {
			el.innerHTML = marked.parse(binding.value);
		} else if (el.innerHTML) {
			el.innerHTML = marked.parse(el.innerHTML);
		}
	},
};
